import { isValidDate, isEmpty } from '@fretadao/f-js-utils';

export function numberValidator(value){
  return (value) => !isNaN(value);
}

export function optionalNumberValidator(value){
  return (value) => isEmpty(value) || !isNaN(value);
}

export function enumValidator(...allowedFields){
  return (value) => allowedFields.includes(value.toLowerCase());
}

export function optionalDateValidator(){
  return (value) => isEmpty(value) || isValidDate(value, { locale: 'pt-BR' })
}
